'use client';
import * as React from 'react';
import Desktop from './desktop';
import Mobile from './mobile';
import { useRouter, usePathname } from 'next/navigation';

import { useProfile, useProfileStore } from '@/profile';
import { useFirebaseAuth } from '@/shared/hooks';
import { useAuthStore } from '@/auth';
import { getProfile } from 'src/modules/profile/me/services/get-profile';
import { isRight } from '@shared-commons/utils';
import { deepEqual } from 'src/shared/utils/objects-deep-equal';

const MainHeader: React.FC = () => {
  const router = useRouter();
  const pathname = usePathname();
  const isPaymentUpdatePage = pathname === '/aggiorna-pagamento';
  const { user } = useAuthStore();
  const auth = useFirebaseAuth();
  const { setProfile } = useProfile(null);
  const handleRedirect = React.useCallback((url: string) => router.push(url), [router]);
  const [showLinks, setShowLinks] = React.useState(true);

  React.useEffect(() => {
    const fetchAccessTokenAndProfile = async () => {
      try {
        if (auth?.currentUser) {
          const token = await auth.currentUser.getIdToken(true);
          if (user?.email) {
            const profile = await getProfile(user.email, token)();
            const storeProfile = useProfileStore.getState().profile; // current profile store value
            if (isRight(profile)) {
              // redirect to update payment method if needsToUpdatePayment is set to true
              if (!isPaymentUpdatePage && profile?.value?.needsToUpdatePayment === true) {
                router.push('/aggiorna-pagamento');
                return;
              }
              // customer without a profile needs to be redirected to onboarding
              if (!profile?.value?.email) {
                router.push('/profilo/onboarding/start');
                return;
              }
              // if we are in an subscriber route redirect
              if (
                profile.value?.subscriber === true &&
                ['/abbonati'].includes(window.location.pathname)
              ) {
                handleRedirect('/profilo/acquisti');
                return;
              }
              // check if fetched profile object is different from current stored profile object
              if (!deepEqual(profile.value, storeProfile)) {
                setProfile(profile.value); // update profile store with newly fetched profile
              }
            } else {
              console.error('Error fetching profile from header');
            }
          }
        }
      } catch {
        console.error('Error fetching latest profile for header');
      }
    };
    fetchAccessTokenAndProfile();
  }, [auth, user, setProfile, pathname]);

  React.useEffect(() => {
    const show = !isPaymentUpdatePage;
    setShowLinks(show);
  }, [isPaymentUpdatePage]);

  return (
    <>
      <Desktop showLinks={showLinks} />
      <Mobile showLinks={showLinks} />
    </>
  );
};

export default MainHeader;
